var map = {
	"./adjust/index.js": 1293,
	"./filter/index.jsx": 342,
	"./modify/index.js": 1297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2753;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/registration/product/inventory \.\/[^\/]+\/index\.jsx?$
// module id = 2753
// module chunks = 0